export default __webpack_public_path__ + "static/media/snorkel.e772eb5f.png";